import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Stack, Tooltip, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function AdvisorNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="auto_awesome"
      nodeData={{ ...data, label: data?.label || 'Processeur' }}
      color="primary"
      handleConf={handleConf}
      onDeleteNode={onDeleteNode}
      onEditNode={onEditNode}
    >
      <Stack spacing={1} sx={{ p: 1, width: '280px' }}>
        <CompactNodeField
          label={msg({ id: 'field.description.label' })}
          value={data?.description || ''}
          shrink
          endAdornment={
            <Tooltip title={msg({ id: 'tooltip.clear' })}>
              <IconButton size="small">
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          }
        />
      </Stack>
    </BaseNode>
  );
}

AdvisorNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
